<template>
  <div class="ac-card-content">
    <div class="launch-visit-body-container">
      <button
        type="button"
        class="launch-visit-button-container"
        @click="showExample"
      >
        <img
          class="launch-visit-button"
          src="@shared/assets/img/general/virtual-visit-play.svg"
          alt="play"
        >
        <span class="launch-visit-button-txt">
          Watch Example
        </span>
      </button>
      <button
        type="button"
        class="launch-visit-button-container"
        @click="showVirtualVisitPdf"
      >
        <img
          class="launch-visit-button"
          src="@shared/assets/img/general/virtual-visit-view-guide.svg"
          alt="view"
        >
        <span class="launch-visit-button-txt">
          View Guide
        </span>
      </button>
      <button
        :id="loomButtonId"
        type="button"
        :class="[
          'launch-visit-button-container',
          loomSettingUp ? 'disabled' : 'active',
        ]"
        :disabled="loomSettingUp"
        @click="launchVV"
      >
        <div class="pos-relative">
          <img
            class="launch-visit-button"
            src="@shared/assets/img/general/virtual-visit-record.svg"
            alt="launch"
          >
          <div class="abs-full flex-center-column just-center">
            <div
              v-if="loomSettingUp"
            >
              Setting Up...
            </div>
            <div
              v-else
            >
              Record
            </div>
          </div>
        </div>
        <span class="launch-visit-button-txt">
          Record New Visit
        </span>
      </button>
    </div>
  </div>
</template>
<script>
import { setup } from '@loomhq/record-sdk';
import customerDetailMixin from '@shared/mixins/customerDetailMixin';
import { oembed } from '@loomhq/loom-embed';
import apiClient from '@shared/lib/general/apiClient';

export default {
  name: 'LaunchVirtualVisit',
  mixins: [customerDetailMixin],
  data() {
    return {
      loomSettingUp: true,
    };
  },
  computed: {
    loomButtonId() {
      return `loom-record-${Math.floor(Math.random() * 100)}-btn`;
    },
  },
  mounted() {
    this.setUpLoom();
  },
  methods: {
    showVirtualVisitPdf() {
      window.open('https://smac-images.s3.us-west-2.amazonaws.com/email/virtual-visit-info.pdf', '_blank');
    },
    showExample() {
      this.toggleActionModal(true, 'example-virtual-visit');
    },
    launchVV() {
      this.toggleActionModal(false);
    },
    async setUpLoom() {
      this.loomSettingUp = true;
      const button = document.getElementById(this.loomButtonId);
      const { configureButton } = await setup({
        publicAppId: process.env.LOOM_APP_ID,
        environment: 'sandbox',
        config: {
          insertButtonText: 'Save Video',
          styles: {
            fontFamily: 'Poppins',
          },
        },
      });
      const sdkButton = configureButton({ element: button });
      sdkButton.on('lifecycle-update', this.handleCycleUpdate);
      sdkButton.on('insert-click', this.handleSave);
      sdkButton.on('recording-start', this.handleStart);
      sdkButton.on('recording-complete', this.handleRecordComplete);
      sdkButton.on('cancel', this.handleCancel);
      this.loomSettingUp = false;
    },
    handleRecordComplete(video) {
      this.newVideo = video;
      this.$store.dispatch('changeCustomerDetailValues', [{
        field: 'recordingInProgress',
        value: false,
      }]);
    },
    handleCycleUpdate() {
      if (document.getElementById('loom-sdk-record-overlay-shadow-root-id')) {
        const host = document.getElementById('loom-sdk-record-overlay-shadow-root-id');
        if (!this.styleAdded) {
          const sheet = new CSSStyleSheet();
          sheet.replaceSync('.em-lns-1nmpalf { display: none; } .em-lns-1a2xxne { display: none; } ');
          host.shadowRoot.adoptedStyleSheets.push(sheet);
          this.styleAdded = true;
        }
      }
    },
    async handleSave() {
      const vid = await oembed(this.newVideo.sharedUrl, { width: 400 });
      const video = {
        ...vid,
        ...this.newVideo,
      };
      const virtualVisit = await this.$store.dispatch('saveVirtualVisit', { virtualVisit: video });
      this.editVirtualVisit(virtualVisit);
    },
    async editVirtualVisit(vv) {
      this.$store.dispatch('changeCustomerDetailValues', [{
        field: 'selectedVirtualVisit',
        value: vv,
      }]);
      let tech = null;
      let avatarUri = null;
      if (this.customer.technicianId) {
        tech = await this.getTech();
        avatarUri = await this.getAvatarImg(tech.profileUrl);
      }
      this.toggleActionModal(true, 'edit-visit', tech, avatarUri);
    },
    async getTech() {
      const { data } = await apiClient({
        method: 'GET',
        url: `/technicians/id/${this.customer.technicianId}`,
      });
      return data;
    },
    async getAvatarImg(url) {
      try {
        const { data } = await apiClient({
          method: 'PUT',
          url: '/devices/ac/image/response',
          data: {
            url,
          },
        });
        return data;
      } catch (err) {
        console.error(err);
      }
    },
    handleCancel() {
      this.$store.dispatch('changeCustomerDetailValues', [{
        field: 'recordingInProgress',
        value: false,
      }]);
    },
    handleStart() {
      this.$store.dispatch('changeCustomerDetailValues', [{
        field: 'recordingInProgress',
        value: true,
      }]);
    },
  },

};
</script>
<style style lang="scss">

.launch-visit-body-container {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-left: 30px;
  margin-right: 30px;

  .launch-visit-button-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    font-size: 18px;
    font-weight: 500;
    color: $WHITE;
    &.active {
      animation: fadeInButton .5s ease forwards;
    }
    &:hover {
      opacity: 0.5 !important;
    }
    &.disabled {
      opacity: 0.4 !important;
      cursor: initial;
    }
    .launch-visit-button {
      width: 128px;
      height: 128px;
    }

    .launch-visit-button-txt {
      font-size: 24px;
      font-weight: 600;
      margin-top: 20px;
      color: $N100;
    }

  }
  .loom-loading {
    background-color: rgba(0, 0, 0, 0.1) !important;
    border-radius: 5px;
  }
}

@keyframes fadeInButton {
  0% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
</style>
